import { useApiList } from '@/composables/api'
import useConfiguration from '@/composables/configuration/configuration'
import { PostReport } from '@/model/data-object/PostReport'

const { configuration } = useConfiguration()

function getReportedPosts(offset: number) {
  return useApiList<Array<PostReport>>('/api/prv/v1/postReport', {
    params: {
      offset: offset,
      limit: configuration.profilePageSize,
    },
  })
}

export default function usePostReportApi() {
  return {
    getReportedPosts,
  }
}
